var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUwalk5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 114,
    viewBox: "0 0 115 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_390_4158)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    width: 87,
    height: 87,
    rx: 3.40448,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2387 79.2899C50.9176 79.072 59.0531 84.9731 64.6806 84.8667C70.3081 84.7603 82.0698 81.3031 81.5851 55.4119C81.1004 29.5207 65.1282 26.0179 58.9366 26.1327C29.9496 26.6749 18.5527 79.6767 39.2387 79.2899Z",
    fill: "url(#paint0_linear_390_4158)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8408 78.7129H25.463V77.024H28.8408V78.7129Z",
    fill: "#D4D8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5527 78.7129H35.1749V77.024H38.5527V78.7129Z",
    fill: "#D4D8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6426 84.623H30.9537V81.2452H32.6426V84.623Z",
    fill: "#D4D8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6426 74.9121H30.9537V71.5343H32.6426V74.9121Z",
    fill: "#D4D8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1326 33.6227C85.5294 33.6227 86.666 34.7593 86.666 36.1561C86.666 37.5528 85.5294 38.6895 84.1326 38.6895C82.7359 38.6895 81.5992 37.5528 81.5992 36.1561C81.5992 34.7593 82.7359 33.6227 84.1326 33.6227ZM84.1326 37.0005C84.5988 37.0005 84.9771 36.6205 84.9771 36.1561C84.9771 35.6916 84.5988 35.3116 84.1326 35.3116C83.6665 35.3116 83.2882 35.6916 83.2882 36.1561C83.2882 36.6205 83.6665 37.0005 84.1326 37.0005Z",
    fill: "#D4D8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3445 38.6899V56.4236C70.3445 57.8221 69.2095 58.957 67.8111 58.957H71.6111C73.0096 58.957 74.1445 57.8221 74.1445 56.4236V38.6899C74.1445 37.2915 73.0096 36.1566 71.6111 36.1566H67.8111C69.2095 36.1566 70.3445 37.2915 70.3445 38.6899Z",
    fill: "#F7F7F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2138 74.9389C35.8547 74.9389 33.1211 72.258 33.1211 68.9636C33.1211 65.6692 35.8547 62.9883 39.2138 62.9883C42.573 62.9883 45.3066 65.6692 45.3066 68.9636C45.3066 72.258 42.573 74.9389 39.2138 74.9389ZM39.2138 65.9759C37.5343 65.9759 36.1675 67.3164 36.1675 68.9636C36.1675 70.6108 37.5343 71.9513 39.2138 71.9513C40.8934 71.9513 42.2602 70.6108 42.2602 68.9636C42.2602 67.3164 40.8934 65.9759 39.2138 65.9759Z",
    fill: "#433ED1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5224 59.0073C56.1633 59.0073 53.4297 56.3263 53.4297 53.032C53.4297 49.7376 56.1633 47.0566 59.5224 47.0566C62.8816 47.0566 65.6152 49.7376 65.6152 53.032C65.6152 56.3263 62.8816 59.0073 59.5224 59.0073ZM59.5224 50.0443C57.8429 50.0443 56.4761 51.3848 56.4761 53.032C56.4761 54.6792 57.8429 56.0196 59.5224 56.0196C61.202 56.0196 62.5688 54.6792 62.5688 53.032C62.5688 51.3848 61.202 50.0443 59.5224 50.0443Z",
    fill: "#433ED1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7705 43.0717C72.4113 43.0717 69.6777 40.3908 69.6777 37.0964C69.6777 33.802 72.4113 31.1211 75.7705 31.1211C79.1296 31.1211 81.8632 33.802 81.8632 37.0964C81.8632 40.3908 79.1296 43.0717 75.7705 43.0717ZM75.7705 34.1088C74.0909 34.1088 72.7241 35.4492 72.7241 37.0964C72.7241 38.7436 74.0909 40.0841 75.7705 40.0841C77.45 40.0841 78.8168 38.7436 78.8168 37.0964C78.8168 35.4492 77.45 34.1088 75.7705 34.1088Z",
    fill: "#433ED1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2295 64.7109L54.6188 54.9874L56.5228 57.3207L44.1335 67.0443L42.2295 64.7109Z",
    fill: "#433ED1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0322 48.4502L71.091 39.566L73.2451 41.6786L64.1863 50.5628L62.0322 48.4502Z",
    fill: "#433ED1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2441 53.0307C37.885 53.0307 35.1514 50.3498 35.1514 47.0554C35.1514 43.761 37.885 41.0801 41.2441 41.0801C44.6032 41.0801 47.3368 43.761 47.3368 47.0554C47.3368 50.3498 44.6032 53.0307 41.2441 53.0307ZM41.2441 44.0677C39.5645 44.0677 38.1977 45.4082 38.1977 47.0554C38.1977 48.7026 39.5645 50.0431 41.2441 50.0431C42.9237 50.0431 44.2905 48.7026 44.2905 47.0554C44.2905 45.4082 42.9237 44.0677 41.2441 44.0677Z",
    fill: "#433ED1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7705 62.9897C72.4113 62.9897 69.6777 60.3088 69.6777 57.0144C69.6777 53.72 72.4113 51.0391 75.7705 51.0391C79.1296 51.0391 81.8632 53.72 81.8632 57.0144C81.8632 60.3088 79.1296 62.9897 75.7705 62.9897ZM75.7705 54.0267C74.0909 54.0267 72.7241 55.3672 72.7241 57.0144C72.7241 58.6616 74.0909 60.002 75.7705 60.002C77.45 60.002 78.8168 58.6616 78.8168 57.0144C78.8168 55.3672 77.45 54.0267 75.7705 54.0267Z",
    fill: "#433ED1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4912 78.9233C54.132 78.9233 51.3984 76.2424 51.3984 72.948C51.3984 69.6536 54.132 66.9727 57.4912 66.9727C60.8503 66.9727 63.5839 69.6536 63.5839 72.948C63.5839 76.2424 60.8503 78.9233 57.4912 78.9233ZM57.4912 69.9603C55.8116 69.9603 54.4448 71.3008 54.4448 72.948C54.4448 74.5952 55.8116 75.9356 57.4912 75.9356C59.1707 75.9356 60.5375 74.5952 60.5375 72.948C60.5375 71.3008 59.1707 69.9603 57.4912 69.9603Z",
    fill: "#433ED1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6104 52.1025L45.2059 50.537L56.1288 67.9549L53.5333 69.5204L42.6104 52.1025Z",
    fill: "#433ED1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2822 68.5498L70.9768 59.2391L72.9996 61.4739L62.305 70.7846L60.2822 68.5498Z",
    fill: "#433ED1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_390_4158",
    x: 0.722534,
    y: 0.0843256,
    width: 113.555,
    height: 113.555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.36179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.63873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_390_4158"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_390_4158",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_390_4158",
    x1: 55.1436,
    y1: 84.8682,
    x2: 55.1436,
    y2: 26.1301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F2FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUwalk5);
export default __webpack_public_path__ + "static/media/uwalk5.f5d778b1f9e0e3f9152db406b2222399.svg";
export { ForwardRef as ReactComponent };